import React, { createContext, useState, useContext } from "react";
import type { ReactNode } from "react"; // Використовуємо type-only import

// Створюємо інтерфейс для контексту
interface PopupFormContextType {
  isOpenForm: boolean;
  openForm: () => void;
  closeForm: () => void;
}

const PopupFormContext = createContext<PopupFormContextType | undefined>(
  undefined
);

// Провайдер контексту для форми
export const PopupFormProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isOpenForm, setIsOpen] = useState(false);

  const openForm = () => setIsOpen(true); // Функція для відкриття форми
  const closeForm = () => setIsOpen(false); // Функція для закриття форми

  return (
    <PopupFormContext.Provider value={{ isOpenForm, openForm, closeForm }}>
      {children}
    </PopupFormContext.Provider>
  );
};

// Хук для доступу до контексту
export const usePopupForm = () => {
  const context = useContext(PopupFormContext);
  if (!context) {
    throw new Error("usePopupForm must be used within a PopupFormProvider");
  }
  return context;
};
